import React from "react";
import SocialMedia from "./SocialMedia";
import { Link } from "react-router-dom";

const Contact = () => {
  return (
    <div className="bg-brand_nero flex flex-col justify-center items-center h-full py-24 my-auto text-white  w-full">
      <div className="bg-brand_jaguar h-[500px] px-24 flex flex-col justify-center items-center w-[700px]">
        <img
          className="h-[150px]"
          src="https://avatars.githubusercontent.com/u/36602276?v=4"
          alt="suraj"
        />
        <h1 className="text-2xl my-3 text-white">Suraj Bahadur</h1>
        <h1 className="my-3 text-white"> Full Stack Developer • Content Creator</h1>

        <Link target="_blank" to='https://itsmesuraj.com/'>
          
          <span className="text-sm  text-brand_yellow">itsmesuraj.com</span>
        </Link>
      </div>
      <SocialMedia />
      
    </div>
  );
};

export default Contact;
